import axios from "axios";

import { IP } from "../utils/Host";


export function updateZmienCzasTrwaniaGrupyOprawa(drop_grupa_global_id,nowy_koniec,fechGrupyOprawaForProcesor) {

// id = procesor id

  axios.get(IP + "zmienCzasTrwaniaGrupyOprawa/"+drop_grupa_global_id+"/"+nowy_koniec)
    .then((res) => {

      console.log("Oprawa przerwa")
      console.log("drop_grupa_global_id"+drop_grupa_global_id)
      console.log("nowy_koniec"+nowy_koniec)

    // console.log("procesor " +res.data[0].mcr)
    // fechparametryTechnologii
    fechGrupyOprawaForProcesor(res.data[0].procesor_id)

    });
}
